module.exports = __webpack_public_path__ + "img/m cn 1.58d4a794.gif";